<template>
  <b-nav-item-dropdown
    id="dropdown-grouped"
    variant="link"
    class="dropdown-language"
    right
  >
    <template #button-content>
      <b-img
        :src="currentLocale.img"
        height="14px"
        width="22px"
        :alt="currentLocale.locale"
      />
      <span class="ml-50 text-body">{{ currentLocale.name }}</span>
    </template>
    <b-dropdown-item
      v-for="localeObj in locales"
      :key="localeObj.locale"
      @click="applyLocale(localeObj.locale)"
    >
      <b-img
        :src="localeObj.img"
        height="14px"
        width="22px"
        :alt="localeObj.locale"
      />
      <span class="ml-50">{{ localeObj.name }}</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import { BNavItemDropdown, BDropdownItem, BImg } from 'bootstrap-vue'
import { setValidationLocale } from '@validations'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BImg,
  },
  // ! Need to move this computed property to comp function once we get to Vue 3
  computed: {
    currentLocale() {
      return this.locales.find(l => l.locale === this.$i18n.locale) || this.locales[0]
    },
  },
  mounted() {
    this.applyLocale(localStorage.getItem('locale') || 'th')
  },
  setup() {
    /* eslint-disable global-require */
    const locales = [
      {
        locale: 'th',
        img: require('@/assets/images/flags/th.png'),
        name: 'Thailand',
      },
      {
        locale: 'en',
        img: require('@/assets/images/flags/en.png'),
        name: 'English',
      },
      // {
      //   locale: 'fr',
      //   img: require('@/assets/images/flags/fr.png'),
      //   name: 'French',
      // },
      // {
      //   locale: 'de',
      //   img: require('@/assets/images/flags/de.png'),
      //   name: 'German',
      // },
      // {
      //   locale: 'pt',
      //   img: require('@/assets/images/flags/pt.png'),
      //   name: 'Portuguese',
      // },

    ]
    /* eslint-disable global-require */

    return {
      locales,
    }
  },
  methods: {
    normalizeLocale(locale) {
      return this.locales.some(l => l.locale === locale) ? locale : 'th'
    },
    applyLocale(locale) {
      const normalizedLocale = this.normalizeLocale(locale)
      this.$i18n.locale = normalizedLocale
      setValidationLocale(normalizedLocale)
      this.saveLocale(normalizedLocale)
    },
    saveLocale(locale) {
      localStorage.setItem('locale', locale)
    },
  },
}
</script>

<style>

</style>
